import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';

import { Document, DocumentGroup } from '../models/document.model';

import { catchError, delay, map, tap } from 'rxjs/operators';
import { DocumentsService } from '../services/sections/documents/documents.service';
import { GlobalSettingsService } from '../services/ui/global-settings.service';

@Injectable({
	providedIn: 'root'
})
export class DocumentsResolver implements Resolve<Observable<DocumentGroup[]>> {
	constructor(
		private router: Router,
		private documentService: DocumentsService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.documentService
			.getDocumentContainerGroupSummary(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				tap(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
				})
			);
	}
}
